export const isNewCustomer = (firstPaymentAt: string | null) => {
  const WEEK_IN_MILLISECONDS = 7 * 24 * 60 * 60 * 1000

  return !!firstPaymentAt && new Date(firstPaymentAt) >= new Date(Date.now() - WEEK_IN_MILLISECONDS)
}
